export default __webpack_public_path__ + "static/media/Phone.ddcad0ea.svg";